import { createStyles } from '@mantine/core';

export const usePickButtonStyles = createStyles((theme) => ({
  growableSmallButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: `${theme.other.spacing._4}px ${theme.other.spacing._8}px`,
    gap: theme.other.spacing._4,
    minWidth: '75px',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    // `&&` doubles the selector so this outranks the fixed 32px height of Button size="small".
    '&&': {
      height: 'auto',
      minHeight: theme.other.spacing._40,
    },
  },
  textColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));
